import { Link } from "@/navigation";
import React from "react";
import { useTranslations } from "next-intl";
import { MENU_GROUPS } from "@/lib/categoriesMenuGroups";

const CategoriesMenuTwo = ({ locale: _locale }: { locale: string }) => {
	const t = useTranslations();

	return (
		<div className="absolute left-0 max-h-[500px] w-screen origin-top scale-y-0 transform rounded-b-sm border-t border-t-gray-300 bg-gray-50 px-3 py-5 shadow transition-all duration-500 ease-in-out group-hover:visible group-hover:scale-y-100 group-hover:opacity-100">
			<ul className="container grid grid-cols-6 gap-x-6 gap-y-4">
				{MENU_GROUPS.map((group) => (
					<li key={group.groupLabelKey} className="relative">
						{/* 顶层分组标题：不跳转、仅展示 */}
						<div className="border-b border-b-gray-400 py-2">
							<span className="font-bold text-gray-900">{t(group.groupLabelKey)}</span>
						</div>
						<ul className="mt-1 grid w-full grid-cols-1">
							{group.items.map((item) => (
								<li
									key={item.labelKey}
									className="relative inline-block w-full p-1 transition-all duration-700"
								>
									<Link href={`/${item.slug}`} className="block w-full text-black hover:text-themePrimary400">
										{t(item.labelKey)}
									</Link>
								</li>
							))}
						</ul>
					</li>
				))}
			</ul>
		</div>
	);
};

export default CategoriesMenuTwo;
